import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Box, Spinner, Heading, Button, useToast, HStack, Badge } from "@chakra-ui/react";
import GRLCPlacementEditorRefactored from "./GRLCPlacementEditorRefactored";
import Navbar from "./Navbar";

const GRLCPlacementEditorPageRefactored = () => {
  const { productCode, contractId } = useParams();
  const [contract, setContract] = useState(null);
  const [loading, setLoading] = useState(true);
  const toast = useToast();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchContract = async () => {
      try {
        const res = await fetch(`https://poc.mrc.ai/${productCode}/api/contracts/${contractId}`);
        const data = await res.json();
        setContract(data);
      } catch (err) {
        toast({ title: "Failed to load contract", status: "error" });
      } finally {
        setLoading(false);
      }
    };
    fetchContract();
  }, [productCode, contractId, toast]);

  if (loading) return <Spinner size="xl" />;

  return (
    <Box position="relative" width="100%" minHeight="100vh">
      <Navbar />

      {/* Version indicator and switch */}
      <Box p={4} bg="blue.50" borderBottom="1px" borderColor="blue.200">
        <HStack justify="space-between">
          <HStack>
            <Badge colorScheme="blue" fontSize="md" px={3} py={1}>
              Refactored Version
            </Badge>
            <Heading size="sm" color="blue.700">
              50% less code • Modular architecture • Same functionality
            </Heading>
          </HStack>
          <Button
            size="sm"
            colorScheme="gray"
            onClick={() => navigate(`/product/${productCode}/contract/${contractId}/placement`)}
          >
            Switch to Original Version
          </Button>
        </HStack>
      </Box>

      <GRLCPlacementEditorRefactored contractInstance={contract} productTemplate={null}/>
    </Box>
  );
};

export default GRLCPlacementEditorPageRefactored;
